var translation = {
	Navatar: {
		header: "โปรไฟล์ AWS",
		subheader: "โปรไฟล์ของคุณช่วยปรับปรุงการโต้ตอบกับประสบการณ์ AWS ที่คัดเลือกมา",
		profileButtonText: "ดูโปรไฟล์",
		logOutText: "ออกจากระบบ",
		logInText: "เข้าสู่ระบบ",
		createProfileText: "สร้างโปรไฟล์",
		federateLoginModalTitle: "ใช้ Midway เพื่อเข้าถึงโปรไฟล์ AWS ของคุณ",
		federateLoginModalFirstDescription: "ในฐานะพนักงาน Amazon เราขอแนะนำให้ใช้ Midway เพื่อเข้าถึงโปรไฟล์ AWS ของคุณ วิธีการรักษาความปลอดภัยที่แนะนำนี้ช่วยให้สามารถผสานรวมเข้ากับระบบภายในได้อย่างราบรื่น",
		federateLoginModalSecondDescription: "คุณเห็นข้อความนี้ เนื่องจากคุณได้เข้าสู่ระบบด้วยที่อยู่อีเมล Amazon โดยใช้ ID ตัวสร้างของ AWS ข้อความนี้จะปรากฏขึ้นทุกครั้งที่คุณเข้าสู่ระบบ จนกว่าคุณจะเปลี่ยนไปใช้ Midway หรือเลือกที่จะดำเนินการเข้าสู่ระบบปัจจุบันต่อไป",
		federateLoginModalPrimaryButton: "ลงชื่อเข้าใช้ด้วย Midway",
		federateLoginModalSecondaryButton: "ดำเนินการต่อด้วย ID ตัวสร้างของ AWS"
	}
};
var Navatar = {
	translation: translation
};

export { Navatar as default, translation };
